import type { TravelerInformation as ApiTravelerInformation } from '@/shared/types/api.types'
import type { MemberInformation } from './components/TravelerCard/TravelerCard.types'
import { TravelDirection } from '@/shared/types/common.types'
import { parseDateFromStr } from '@/shared/utils'

const getOutboundInformation = (traveler: ApiTravelerInformation) => ({
  withWinterSport: !!traveler.winSports,
})

const getGeneralInformation = (traveler: ApiTravelerInformation) => {
  return {
    dateOfBirth: parseDateFromStr(traveler.dateOfBirth),
    nationality: traveler.nationalityName,
    passportNumber: traveler.passportNo,
    relation: (() => {
      const relation = traveler.relationName
      const firstLetter = relation.charAt(0)
      const restWord = relation.slice(1).toLowerCase()
      return `${firstLetter}${restWord}`
    })(),
  }
}

export const getTravelersInformation = (
  travelers: ApiTravelerInformation[],
  typeOfTravel: TravelDirection = TravelDirection.OUTBOUND,
  withWinterSport: boolean
): { information: MemberInformation; name: string; id: string }[] => {
  return travelers.map((traveler) => {
    const winterSportInformation = withWinterSport ? getOutboundInformation(traveler) : {}
    return {
      name: traveler.firstName + ' ' + traveler.lastName,
      id: String(traveler.srNo),
      information:
        typeOfTravel === TravelDirection.OUTBOUND
          ? {
              ...getGeneralInformation(traveler),
              ...winterSportInformation,
            }
          : getGeneralInformation(traveler),
    }
  })
}
